import React from "react";

// =============================================================================
// HOVER TOOLTIP — CSS-only, no portal
// =============================================================================
// Wraps any child with a hover tooltip showing label, formula, and live
// computation. Positioning: absolute below the child, z-20.
//
// RULES:
// - Wrap the CONTENTS of a <td>, not the <td> itself (preserves table layout).
// - NO transform on hover states — causes backdrop-filter blur (css-glass rule).
// - Surface uses tt-surface (shared tooltip SSOT class) for bg/border/radius/shadow.
// =============================================================================

const HoverTooltip: React.FC<{
  label: string;
  formula: string;
  computation: string;
  children: React.ReactNode;
}> = ({ label, formula, computation, children }) => (
  <div className="relative group">
    {children}
    <div className="pointer-events-none absolute left-0 top-full mt-1 z-20 hidden group-hover:block w-72 p-3 tt-surface">
      <p className="token-11 text-glass-muted uppercase">{label}</p>
      <p className="token-13 text-glass mt-1 font-mono">{formula}</p>
      <p className="token-13 text-ds-accent mt-1 font-mono">{computation}</p>
    </div>
  </div>
);

export default HoverTooltip;
